import {
  Alert,
  AlertIcon,
  Button,
  Collapse,
  Flex,
  FormControl,
  FormLabel,
  Input,
  Select,
  useToast,
} from "@chakra-ui/react";
import { Post } from "api";
import { useCallback, useEffect, useState } from "react";
import { extractIosAppId, extractPackageName } from "utils";

export default function SingularTab() {
  const toast = useToast();
  const [trackingUrl, setTrackingUrl] = useState("");
  const [storeUrl, setStoreUrl] = useState("");
  const [platform, setPlatform] = useState("");

  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    setSuccess(false);
  }, [trackingUrl, storeUrl, platform]);

  useEffect(() => {
    const onFocus = () => {
      setSuccess(false);
    };
    window.addEventListener("focus", onFocus);

    return () => {
      window.removeEventListener("focus", onFocus);
    };
  }, []);

  const onValidatePress = useCallback(async () => {
    setSuccess(false);
    setLoading(true);
    try {
      const platformId = platform === "android" ? 1 : 2;
      const storeId =
        platformId === 1
          ? extractPackageName(storeUrl)
          : extractIosAppId(storeUrl);

      if (!storeId) {
        toast({
          title: "Error",
          description: "Invalid Store URL for Platform",
          status: "error",
          duration: 9000,
          isClosable: true,
        });
        setLoading(false);
        return;
      }

      const body = {
        trackingUrl,
        platformId,
        storeId,
        mmp: "singular",
      };

      const response = await Post("/manage/link-builder/validate", body);
      if (!response.error) {
        toast({
          title: "Success",
          description: "Link is valid",
          status: "success",
          duration: 9000,
          isClosable: true,
        });
        setSuccess(true);
      } else {
        toast({
          title: "Error",
          description: response.reason ?? response.error,
          status: "error",
          duration: 9000,
          isClosable: true,
        });
      }
    } catch (error) {
      console.warn(error);
    } finally {
      setLoading(false);
    }
  }, [platform, storeUrl, toast, trackingUrl]);

  return (
    <Flex flexDir={"column"} gap={4} pt={8}>
      <Collapse in={success}>
        <Alert status="success">
          <AlertIcon />
          Link is valid.
        </Alert>
      </Collapse>
      <FormControl>
        <FormLabel>Tracking URL</FormLabel>
        <Input
          placeholder="Tracking URL"
          onChange={(e) => setTrackingUrl(e.target.value)}
          mb={4}
        />
        <FormLabel>Store URL</FormLabel>
        <Input
          placeholder="Store URL"
          onChange={(e) => setStoreUrl(e.target.value)}
          mb={4}
        />
        <FormLabel>Platform</FormLabel>
        <Select
          placeholder="Select a platform"
          onChange={(e) => setPlatform(e.target.value)}
          mb={4}
        >
          <option value="ios">iOS</option>
          <option value="android">Android</option>
        </Select>
        <Flex justify={"flex-end"}>
          <Button
            colorScheme={"whatsapp"}
            onClick={onValidatePress}
            isLoading={loading}
            isDisabled={loading || !trackingUrl || !storeUrl || !platform}
          >
            Validate
          </Button>
        </Flex>
      </FormControl>
    </Flex>
  );
}
